import { Component, input } from '@angular/core';

@Component({
  selector: 'rfa-submit-error',
  templateUrl: './rfa-submit-error.component.html',
})
export class RfaSubmitErrorComponent {
  readonly errorTitle = input('Verzenden mislukt');
  readonly errorMessage = input(
    'Er is helaas iets fout gegaan bij het verzenden van uw formulier. Probeer het later nog eens.'
  );
}
